import type { SiteLocale } from '@/lib/i18n/locales';

type UiDictionary = {
  nav: {
    services: string;
    contact: string;
    aiAssistant: string;
    loading: string;
    myCases: string;
    myProfile: string;
    signOut: string;
    signIn: string;
    register: string;
    openMenu: string;
    closeMenu: string;
    menuSrOnly: string;
  };
  language: {
    switchLanguage: string;
    switchToEnglish: string;
    switchToSpanish: string;
  };
};

const ES_DICTIONARY: UiDictionary = {
  nav: {
    services: 'Servicios',
    contact: 'Contacto',
    aiAssistant: 'Recomendador legal',
    loading: 'Cargando...',
    myCases: 'Mis Expedientes',
    myProfile: 'Mi perfil',
    signOut: 'Cerrar sesión',
    signIn: 'Iniciar sesión',
    register: 'Registrarse',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    menuSrOnly: 'Menu',
  },
  language: {
    switchLanguage: 'Idioma',
    switchToEnglish: 'Switch to English',
    switchToSpanish: 'Cambiar a español',
  },
};

const EN_DICTIONARY: UiDictionary = {
  nav: {
    services: 'Services',
    contact: 'Contact',
    aiAssistant: 'Legal recommender',
    loading: 'Loading...',
    myCases: 'My Cases',
    myProfile: 'My profile',
    signOut: 'Sign out',
    signIn: 'Sign in',
    register: 'Create account',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    menuSrOnly: 'Menu',
  },
  language: {
    switchLanguage: 'Language',
    switchToEnglish: 'Switch to English',
    switchToSpanish: 'Cambiar a español',
  },
};

export function getUiDictionary(locale: SiteLocale): UiDictionary {
  return locale === 'es' ? ES_DICTIONARY : EN_DICTIONARY;
}
